module.exports = __webpack_public_path__ + "static/4-2-x@3x-1cfb0b1e3f0aacdf4d9dd8315e51e446.png";